var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui labels",attrs:{"slot":"labels"},slot:"labels"},_vm._l((_vm.options),function(option){return _c('span',[_c('Tag',{attrs:{"option":option,"selected":_vm.selected}})],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39e0e8ee","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Labels.vue
// module id = 229
// module chunks = 0